import { Row, Table } from '@tanstack/table-core';
import React, { MutableRefObject, ReactElement, useMemo } from 'react';

import { TableProps } from '../types';

import TableRow from './Row';
import { styEmptyBody, styTbody } from './style';

import RowLoader from './RowLoader';

function TableBody<TData>({
  rows,
  parentRef,
  renderRowExpand,
  isInitialLoading,
  isFetchingNext,
  table,
  emptyStateContent,
}: {
  rows: Row<TData>[];
  parentRef: MutableRefObject<HTMLElement>;
  renderRowExpand: TableProps<TData>['renderRowExpand'];
  isInitialLoading: TableProps<TData>['isInitialLoading'];
  isFetchingNext: TableProps<TData>['isFetchingNext'];
  table: Table<TData>;
  emptyStateContent: React.ReactNode;
}) {
  const cellCount = useMemo(() => table?.getVisibleLeafColumns()?.length || 0, [table]);

  const isEmptyData = !isInitialLoading && rows.length === 0;

  return (
    <tbody className={styTbody}>
      {isEmptyData && (
        <tr>
          <td colSpan={cellCount}>
            <div className={styEmptyBody}>{emptyStateContent}</div>
          </td>
        </tr>
      )}

      {rows.map((row): ReactElement => {
        return <TableRow<TData> key={row.id} row={row} renderRowExpand={renderRowExpand} />;
      })}

      <RowLoader
        cellCount={cellCount}
        isInitialLoading={isInitialLoading}
        isFetchingNext={isFetchingNext}
      />
    </tbody>
  );
}

export default TableBody;
